import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from '../Model';
export default class Group extends Model {
  nameSingular() {
    return Model.attribute('nameSingular').call(this);
  }
  namePlural() {
    return Model.attribute('namePlural').call(this);
  }
  color() {
    return Model.attribute('color').call(this);
  }
  icon() {
    return Model.attribute('icon').call(this);
  }
  isHidden() {
    return Model.attribute('isHidden').call(this);
  }
}
_defineProperty(Group, "ADMINISTRATOR_ID", '1');
_defineProperty(Group, "GUEST_ID", '2');
_defineProperty(Group, "MEMBER_ID", '3');
flarum.reg.add('core', 'common/models/Group', Group);